/** Тикеры акций/ETF на MOEX через T-Invest: латиница и цифры, до 12 символов. */
export const MARKET_TICKER_RE = /^[A-Z0-9]{1,12}$/;
export function normalizeTickerInput(raw) {
    return raw.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 12);
}
export function isValidMarketTicker(ticker) {
    return MARKET_TICKER_RE.test(ticker.trim().toUpperCase());
}
